export default "__VITE_ASSET__a0zX1uTS__"